import { render, staticRenderFns } from "./TableQuestion.vue?vue&type=template&id=24bb7880&scoped=true"
import script from "./TableQuestion.vue?vue&type=script&lang=js"
export * from "./TableQuestion.vue?vue&type=script&lang=js"
import style0 from "./TableQuestion.vue?vue&type=style&index=0&id=24bb7880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bb7880",
  null
  
)

export default component.exports